import React, { useState, useEffect, useRef } from "react";
import { Search } from "lucide-react";
import "./CustomFilterSelect.css";

const CustomFilterSelect = ({ 
  label, 
  value, 
  onChange, 
  options = [], 
  isLoading = false, 
  disabled = false, 
  width = "220px" 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const handleToggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  // Handle selection
  const handleOptionClick = (option) => {
    onChange({ target: { value: option.id } });
    setIsOpen(false);
  };

  useEffect(() => {
    if (options.length) {
      setFilteredOptions(
        searchQuery.trim()
          ? options.filter((opt) => opt.name.toLowerCase().includes(searchQuery.toLowerCase()))
          : options
      );
    }
  }, [searchQuery, options]);
useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div 
      className={`custom-filter-select-container ${disabled ? "custom-disabled" : ""}`} 
      style={{ width }} 
      ref={dropdownRef}
    >
      <div className="custom-filter-select" onClick={handleToggleDropdown}>
        <span className="custom-filter-label">{value ? options.find(opt => opt.id === value)?.name : label}</span>
        <span className={`custom-filter-select-arrow ${isOpen ? "rotate-180" : ""}`}>
        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="#4B5563"
                            className={`w-5 h-5 ${isOpen ? 'rotate-180' : ''}`}
                        >
                            <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
        </span>
      </div>
      
      {isOpen && (
        <div className="custom-filter-select-dropdown">
       
          <div className="custom-filter-select-search">
            <input
              className="search-input"
              placeholder={`Search ${label.toLowerCase()}`}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Search width={18} />
          </div>

          <div className="custom-filter-select-options">
            {isLoading ? (
              <div className="custom-filter-select-option disabled">Loading...</div>
            ) : filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <div 
                  key={option.id} 
                  className="custom-filter-select-option" 
                  onClick={() => handleOptionClick(option)}
                >
                  {option.name}
                </div>
              ))
            ) : (
              <div className="custom-filter-select-option disabled">No data found </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomFilterSelect;
